import { render, staticRenderFns } from "./RecordAudioQuestion.vue?vue&type=template&id=7745c4ea"
import script from "./RecordAudioQuestion.vue?vue&type=script&lang=js"
export * from "./RecordAudioQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports